import { configureStore } from '@reduxjs/toolkit';

import { apiSlice } from './slices/apiSlice';
import authSliceReducer from './slices/authSlice';
import cartReducer from './slices/cartSlice'; // Import the cart reducer
import orderSliceReducer from './slices/orderSlice';
import idSliceReducer from './slices/idSlice';
import adminSliceReducer from './slices/adminSlice';
import companySliceReducer from './slices/companySlice';
import activeGlobalDiscountReducer from './slices/activeGlobalDiscountSlice';

const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        cart: cartReducer, // Add the cart reducer to the store
        order: orderSliceReducer,
        auth: authSliceReducer,
        id: idSliceReducer,
        admin: adminSliceReducer,
        companies: companySliceReducer,
        activeGlobalDiscount: activeGlobalDiscountReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: true,
});

export default store;
